import * as Cesium from "cesium";
import RadarMaterialProperty from "./material/RadarMaterialProperty";
import { centerRect } from "./effectConfig";

/** 雷达：以光锥中心为圆心 */
export default class RadarLight {
  constructor(viewer, options = {}) {
    this.radarMaterial = new RadarMaterialProperty("radarMaterial");
    // 约 1.5km 见方，罩在光锥周围
    const rect = options.rect ?? centerRect(0.012, 0.01);
    const ground = options.groundHeight ?? 1110;
    this.entity = viewer.entities.add({
      rectangle: {
        coordinates: Cesium.Rectangle.fromDegrees(...rect),
        material: this.radarMaterial,
        height: ground + 30,
        heightReference: Cesium.HeightReference.NONE,
      },
    });
  }

  setVisible(show) {
    this.entity.show = show;
  }
}
